<div
  [ngStyle]="{ 'margin-right': itemSpace }"
  *ngFor="let item of itemList; let last = last; trackBy: itemsToDisplayTrackBy"
  [ngClass]="{ last: last }">
  <div class="action" (click)="onItemClick(item)">
    <ng-template [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ $implicit: item }"></ng-template>
  </div>
</div>
